const ListingSource = ({
    contactEmail = '',
    contactPhone = '',
    dateActivatedTimestamp = '',
    feedName = '',
    listingAlias = '',
    isManual = false,
    photoUrl = '',
    price = 0,
    syndicationStatus = '',
} = {}) => ({
    contactEmail: String(contactEmail),
    contactPhone: String(contactPhone),
    dateActivatedTimestamp: String(dateActivatedTimestamp),
    feedName: String(feedName),
    listingAlias: String(listingAlias),
    isManual: Boolean(isManual),
    photoUrl: String(photoUrl),
    price: Number(price),
    syndicationStatus: String(syndicationStatus),
});

const ListingSourceResponse = ({
    hasManualSource = false,
    street = '',
    listings = [],
} = {}) => ({
    hasManualSource: Boolean(hasManualSource),
    street: String(street),
    sources: listings.map(ListingSource),
});

export default ListingSourceResponse;
